import * as Yup from 'yup';

const schema = Yup.object().shape({
  folderName: Yup.string()
    .required('O campo deve ser preenchido'),
    // TODO Validar nome usado na pasta já existe
});

export default schema;
